import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import isMobile from 'ismobilejs';
let DraggableList = class DraggableList extends Vue {
    get isMobile() {
        return isMobile(navigator.userAgent).any;
    }
    get draggableItems() {
        return this.$props.items;
    }
    set draggableItems(newItems) {
        this.$emit('update', newItems);
    }
};
__decorate([
    Prop(Array)
], DraggableList.prototype, "items", void 0);
__decorate([
    Prop(String)
], DraggableList.prototype, "propName", void 0);
DraggableList = __decorate([
    Component({
        components: {
            Draggable
        }
    })
], DraggableList);
export default DraggableList;
